
export function guards(...gs) {
    let tmpGs = gs.slice(0);
    return function (to, from, next) {
        if (tmpGs.length === 0) {
            next();
            return;
        }
        const currentGuard = tmpGs[0];
        let _next = function (args = null) {
            if (args !== null) {
                next(args);
                return;
            }
            guards(...tmpGs.slice(1))(to, from, next);
        };
        currentGuard(to, from, _next);
    }
};



// WEBPACK FOOTER //
// ./src/router/guards/multi-gaurds.guard.js